import React from 'react';

const Footer = () => {
  const navColumns = [
    {
      heading: 'Services',
      links: [
        { label: 'North America Consulting', href: '#north-america' },
        { label: 'Databricks', href: '#databricks' },
        { label: 'Power Platform', href: '#power-platform' },
        { label: 'AI Consulting', href: '#ai-consulting' },
      ],
    },
    {
      heading: 'Company',
      links: [
        { label: 'Why Choose Us', href: '#services' },
        { label: 'Testimonials', href: '#services' },
        { label: 'Contact', href: '#contact' },
      ],
    },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="text-2xl font-extrabold mb-3">
              Spiked<span className="text-cyan-400">Qcumber</span>
            </div>
            <p className="text-gray-400 leading-relaxed max-w-sm">
              North America's specialized technology consulting partner for Databricks, Microsoft Power Platform, and AI-driven transformation.
            </p>
            <a href="mailto:info@SpikedQcumber.com" className="text-cyan-400 hover:underline mt-3 block text-sm">
              info@SpikedQcumber.com
            </a>
          </div>

          {/* Nav columns */}
          {navColumns.map((col, i) => (
            <div key={i}>
              <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-widest mb-4">{col.heading}</h4>
              <ul className="space-y-2">
                {col.links.map((link, j) => (
                  <li key={j}>
                    <a href={link.href} className="text-gray-400 hover:text-white text-sm transition-colors">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Spiked Qcumber. All rights reserved.
          </p>
          <div className="text-gray-400 text-sm text-right">
            <div>Toronto, ON</div>
            <div className="text-gray-500 text-xs mt-0.5">Proudly serving clients across North America</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
